import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, EffectiveRoleGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const AssignedTasksPage = lazy(() => import('src/pages/assigned-tasks/list'));
const CallSessionPage = lazy(() => import('src/pages/assigned-tasks/session'));

export const assignedTasksRoutes = [
  {
    path: 'assigned-tasks',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ path: '', element: <AssignedTasksPage />, index: true }],
  },
  {
    // Outside DashboardLayout on purpose: the call console is full-bleed and supplies its own
    // top bar and exit control, so the sidebar would only compete with the three columns.
    //
    // EffectiveRoleGuard is mounted explicitly here because DashboardLayout is the only other
    // place it is mounted, and this route is deliberately outside it. Without this the session
    // route would carry AuthGuard alone, while the list route above gets both -- the role half of
    // the spec'd guard (§4.1) would simply be missing on the deeper of the two routes.
    path: 'assigned-tasks/:taskId/session',
    element: (
      <AuthGuard>
        <EffectiveRoleGuard>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </EffectiveRoleGuard>
      </AuthGuard>
    ),
    children: [{ path: '', element: <CallSessionPage />, index: true }],
  },
];
